import React, { useEffect, useState } from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import RequireLogin from './components/RequireLogin';
import Dashboard from './pages/Dashboard';
import Create from './pages/Create';
import { connect } from 'react-redux';

import { setCurrentUser } from './redux/actions';
import { getCurrentListInfo, getUser, isUserReady } from './redux/selectors';
import SideBar from './components/SideBar/SideBar';
import CustomModal from './components/CustomModal/CustomModal';
import Button from './components/Button/Button';
import clsx from 'clsx';
import GetUnlimited from './components/GetUnlimited/GetUnlimited';
import Label from './components/Label/Label';
import Input from './components/Input/Input';
import UpgradeAccountIcon from './components/Icons/UpgradeAccountIcon';
import SubscribeButtons from './components/Stripe/SubscribeButtons';
import { useMediaQuery } from 'react-responsive';
import CloseModalIcon from './components/Icons/CloseModalIcon';
import ResultsTotalCount from './components/ResultsTotalCount/ResultsTotalCount';
import RankedItem from './components/RankedItem/RankedItem';
import RumbleList from './types/RumbleList';
import RumbleItem from './types/RumbleItem';
import SharePage from './pages/SharePage';
import RumbleShowdownPage from './pages/RumbleShowdownPage';
import ListPage from './pages/ListPage';
import WhiteLabelPage from './pages/WhiteLabelPage';
import WhiteLabelInfo from './types/WhiteLabelInfo';

function setCookie(name: string, value: string, days: number) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function App(props: any) {
  // setCookie(
  //   '.AspNetCore.Cookies',
  //   'CfDJ8EnExo-zt6pLrz95Jwi6Z8r2ySqlUsinAH30FvYgLt7ZhJBPEjMhNpZsdI9dFQGOueRfWsAS_rfzHzNG4FBPLy-Zks9TS9M3bh9AkH_kjHjWXpKntCHbkhXh_2TZ1lf5Vg_6CIYJ_IqyOYi1GZAfDYXz_Qf19eYZ13FvRFGxSQzo1XrdrIn-83DvucdjS9Vvrn0zP8ropPlAFoCJiE-MU-qAglcOH9GEfLuJ5C0r7PJcBD8jPLJcib1G6ZAf4thI8MGITnOR9CL7zrbcVxltNepj5XHAKofX0OIqx3YQxYMq7i_S9i1FUfnU9YCF6MKh1M3wvvKEl-eIX1iOVTzY3zQVvi0gbxrIGU1mUbKQaBc0QChBuReftR30tiApxi-UFEaRAnm9npQ3TqdQaqbue-cEZ_B1bAj_u-z0SPPU8JLSdHwIAceX3RrpFMqcPdF4Xs09PykP2vsbpO9cb4RRXC_0WBf1PPwn3ukRzyVNViBSiTakak0pZ9vZtpaDKYHRcszW1lC1J_uDP2OwVoDXKfqP8pus45yNWNzJpZAHXyezhctyKVXKQ4FdUOPtHhuqMj3nekZaapqyzwJemwvqYsdf2RfSnbc4MZSxjOxfu91D80XtNnGtSyKReDrpYvD4bE5vF8e6cF0iJPdyQ4JcKqN1I_CkKzE2PddJ14Fmsx7nQ81lWoRtASRa7tgJMl_qOkw1VENHUYYFh8i6y1BQyUoofhdQ_jZpD71iei_MKk-ryS0tjcWOW8qpX3BY0isfmlz-M22zlTrs0BjVdmEeXOPynQzRGqdYomtg009Apa-rQQlUx06RjamjWA_2Pu1iOz_g3xIP2nAgyG1SlPpZ4emDuJyBOQ5uMjbEyeAGvjLkJDYOGpxcgqt34863RQuBmPkuF9iPoKoWBlibG2wVXoZU7-FQQEf2OkduPvLSly-wOAzOJBPGdFzuFCVsciJVC0yM4qneeOoZs7WSjqZIgySgP4M9aav38cgjzkTuWA7hdonYXmDb7yXzQIqdr84TvRzgR0RneI94Uu00rb4dNpNuKa14s91bg8eCln1Y6eVs5g6Q0Y3RNkVuiQuEDV87KBMcOHlCgXQuuu3Ioqe0nvrygao0P85wq6p1VXnmSVqHjiPvfUa26EpGSInX_vSEa6YTJPvPUJ8vGjv7OFEDJs0dd_ozH2aKNMyvsDGFKPb__XHb68tTHbP08_na_bzP_g',
  //   10
  // );
  useEffect(() => {
    async function getCurrentUser() {
      let resp = await fetch('/api/Account/GetCurrentUser');
      if (resp.ok) {
        let user = await resp.json();
        props.setCurrentUser(user);
        let whiteLabelResp = await fetch('/api/Account/WhiteLabelInfo');
        if (whiteLabelResp.ok) {
          setWhiteLabelInfo(await whiteLabelResp.json());
        }
      } else {
        props.setCurrentUser(null);
      }
    }
    getCurrentUser();
  }, []);
  const [videoModalIsOpen, setVideoModalIsOpen] = useState(false);
  const [logOutModalIsOpen, setLogOutModalIsOpen] = useState(false);
  const [editModalIsOpen, setEditModalIsOpen] = useState(false);
  const [resultsModalIsOpen, setResultsModalIsOpen] = useState(false);
  const [fullModalIsOpen, setFullModalIsOpen] = useState(false);
  const [upgradeIsOpen, setUpgradeIsOpen] = useState(false);
  const [profileIncomplete, setProfileIncomplete] = useState(false);
  const [userName, setUserName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [listItem, setListItem] = useState(null as RumbleList | null);
  const [whiteLabelInfo, setWhiteLabelInfo] = useState(null as WhiteLabelInfo | null);

  const [resultsRumbleID, setResultsRumbleID] = useState<number | null>(null);
  const [duplicateRumbleID, setDuplicateRumbleID] = useState<number | null>(
    null
  );
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  function openVideoModal() {
    setVideoModalIsOpen(true);
    setLogOutModalIsOpen(false);
    setEditModalIsOpen(false);
    setUpgradeIsOpen(false);
    setResultsModalIsOpen(false);
  }

  function openUpgradeModal() {
    setVideoModalIsOpen(false);
    setLogOutModalIsOpen(false);
    setEditModalIsOpen(false);
    setUpgradeIsOpen(true);
    setResultsModalIsOpen(false);
  }

  function openEditModal(e: boolean) {
    setVideoModalIsOpen(false);
    setLogOutModalIsOpen(false);
    setEditModalIsOpen(e);
    setUpgradeIsOpen(false);
    setResultsModalIsOpen(false);
    setFullModalIsOpen(e);
    if (!e) {
      closeModal();
    }
  }

  function openResultsModal(e: boolean) {
    setVideoModalIsOpen(false);
    setLogOutModalIsOpen(false);
    setEditModalIsOpen(false);
    setUpgradeIsOpen(false);
    setResultsModalIsOpen(e);
    setFullModalIsOpen(e);
    if (!e) {
      closeModal();
    }
  }

  useEffect(() => {
    if (resultsRumbleID) {
      getListItem(resultsRumbleID);
    }
  }, [resultsRumbleID]);

  function openLogOutModal() {
    setVideoModalIsOpen(false);
    setLogOutModalIsOpen(true);
    setEditModalIsOpen(false);
    setUpgradeIsOpen(false);
    setResultsModalIsOpen(false);
  }
  function closeModal() {
    setVideoModalIsOpen(false);
    setLogOutModalIsOpen(false);
    setUpgradeIsOpen(false);
    setResultsModalIsOpen(false);
    setFullModalIsOpen(false);
    setListItem(null);
    if (props.user.hasAccount) {
      setEditModalIsOpen(false);
    }
  }
  function getListItem(listId: number) {
    fetch(`/api/RumbleLists/${listId}`)
      .then((resp) => resp.json())
      .then((json) => {
        setListItem(json);
      });
  }
  function sortItems(a: RumbleItem, b: RumbleItem) {
    if (a.aggregatedPlaces === b.aggregatedPlaces) {
      return b.wins - a.wins;
    }
    return a.aggregatedPlaces - b.aggregatedPlaces;
  }
  useEffect(() => {
    if (props.ready && props.user) {
      setUserName(props.user.userName || '');
      setCompanyName(props.user.companyName || '');
      if (!props.user.hasAccount) {
        setProfileIncomplete(true);
        setEditModalIsOpen(true);
      }
    }
  }, [props.user, props.ready]);
  async function saveProfile() {
    if (userName != '' && companyName != '') {
      let response = await fetch('/api/Account/EditProfile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userName, companyName }),
      });
      if (response.ok) {
        const newUserResp = await fetch('/api/Account/GetCurrentUser');
        if (newUserResp.ok) {
          const newUser = await newUserResp.json();
          props.setCurrentUser(newUser);
        }
        setEditModalIsOpen(false);
      }
    }
  }

  let whiteLabelOverrideStyle = undefined;
  if (!props.user && props.currentList?.whiteLabelInfo?.backgroundColor) {
    whiteLabelOverrideStyle = { backgroundColor: props.currentList.whiteLabelInfo["backgroundColor"] };
  }

  return (
    <Router>
      <main className={'flex h-screen'}>
        {props.ready && props.user && (
          <>
            <SideBar
              props={props}
              openVideoModal={openVideoModal}
              openLogOutModal={openLogOutModal}
              openEditModal={openEditModal}
              upgradeModal={openUpgradeModal}
              isMobile={isMobile}
              whiteLabelInfo={whiteLabelInfo}
            />

            <CustomModal
              variant={'video'}
              isOpen={videoModalIsOpen}
              isClose={closeModal}
            >
              <iframe
                className={'max-w-full w-full h-auto aspect-video'}
                width='560'
                height='315'
                src='https://www.youtube.com/embed/pJmiBvOOiUM?si=eXAruy2duVmQw0YF'
                title='YouTube video player'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                allowFullScreen
              ></iframe>
            </CustomModal>
            <CustomModal
              isOpen={logOutModalIsOpen}
              isClose={closeModal}
              variant={'small'}
            >
              <p
                className={
                  'text-center text-primary font-semibold text-16 leading-155 mb-4'
                }
              >
                Do you want to log out?
              </p>
              <div className={'grid grid-cols-2 gap-3'}>
                <Button variant={'secondary'} onClick={closeModal}>
                  Cancel
                </Button>
                <Button
                  tag={'a'}
                  variant={'primary'}
                  to={'/Logout'}
                  onClick={closeModal}
                >
                  Yes, log out
                </Button>
              </div>
            </CustomModal>
            <CustomModal
              isOpen={editModalIsOpen}
              isClose={closeModal}
              variant={'editProfile'}
              disableClose={!props.user.hasAccount}
            >
              <div className={'flex flex-col gap-4'}>
                {!isMobile && (
                  <div className={'flex items-center gap-3'}>
                    <p
                      className={
                        'text-center text-primary font-semibold text-16 leading-155'
                      }
                    >
                      {profileIncomplete
                        ? 'Complete your profile'
                        : 'Edit your profile'}
                    </p>

                    <span
                      className={clsx(
                        'text-12 font-semibold px-1 py-0.5 rounded-4',
                        props.user?.subscriptionTier === 'Free'
                          ? 'bg-green'
                          : 'bg-gradient-to-r from-[#D13A0A] to-[#FFA901]'
                      )}
                    >
                      {props.user?.subscriptionTier === 'Free'
                        ? 'Free'
                        : 'Unlimited'}
                    </span>
                  </div>
                )}
                {props.user?.subscriptionTier === 'Free' ? (
                  <GetUnlimited
                    variant={'dark'}
                    upgradeModal={openUpgradeModal}
                  />
                ) : null}
                <div>
                  <Label htmlFor={'userName'} text={'User name'} />
                  <Input
                    id={'userName'}
                    variant={'text'}
                    placeholder={'Enter user name'}
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>
                <div>
                  <Label htmlFor={'CompanyName'} text={'Company name'} />
                  <Input
                    id={'CompanyName'}
                    variant={'text'}
                    placeholder={'Enter company name'}
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </div>
                <div
                  className={'grid grid-cols-2 gap-3 max-tablet:grid-cols-1'}
                >
                  {!isMobile && (
                    <Button variant={'secondary'} onClick={closeModal}>
                      Back
                    </Button>
                  )}
                  <Button variant={'primary'} onClick={saveProfile}>
                    Save
                  </Button>
                </div>
              </div>
            </CustomModal>
            <CustomModal
              isOpen={resultsModalIsOpen}
              isClose={closeModal}
              variant={'results'}
            >
              {listItem ? (
                <>
                  {!isMobile && (
                    <div
                      className={'flex items-center justify-between gap-5 mb-4'}
                    >
                      <p
                        className={
                          'text-primary text-20 font-semibold leading-140'
                        }
                      >
                        {listItem.name}
                      </p>
                      <button type={'button'} onClick={closeModal}>
                        <CloseModalIcon />
                      </button>
                    </div>
                  )}
                  <div
                    className={
                      'grid grid-cols-1 tablet:grid-cols-2 gap-2 mb-6 max-tablet:mb-4'
                    }
                  >
                    <ResultsTotalCount data={listItem.items} variant={'responses'} />
                  </div>
                  <div className={'w-full text-primary text-left text-13'}>
                    <div className={'flex font-semibold'}>
                      <p
                        className={
                          'flex items-center bg-grayLight p-2 basis-1/2 rounded-tl-3'
                        }
                      >
                        Rankings of all the list items
                      </p>
                      <p
                        className={
                          'flex items-center bg-grayLight p-2 basis-1/4'
                        }
                      >
                        Wins
                      </p>
                      <p
                        className={
                          'flex items-center bg-grayLight p-2 basis-1/4 rounded-tr-3'
                        }
                      >
                        Score
                      </p>
                    </div>
                    <div
                      className={
                        'tablet:max-h-[520px] overflow-y-auto scrollbar scrollbar-thumb-[#E4E4E4] scrollbar-track-grayLight scrollbar-w-1 scrollbar-thumb-rounded-1'
                      }
                    >
                      {listItem.items.sort(sortItems).map((item, index) => {
                        let itemNum = index + 1;
                        return (
                          <RankedItem
                            key={item.id}
                            imageURL={
                              item.imageURL
                                ? item.imageURL
                                : 'img/imagePlaceHolder.jpg'
                            }
                            name={item.name}
                            wins={item.wins}
                            score={item.aggregatedPlaces}
                            itemNum={itemNum}
                          />
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : (
                <p className={'text-center text-primary text-16 leading-150'}>
                  Loading...
                </p>
              )}
            </CustomModal>
            <CustomModal
              isOpen={upgradeIsOpen}
              isClose={closeModal}
              variant={'upgrade'}
            >
              <p
                className={
                  'text-primary text-16 leading-150 font-semibold mb-3'
                }
              >
                Upgrade your account
              </p>
              <p className={'text-primary text-base leading-171 mb-6'}>
                The subscription cost for updating to an unlimited account is
                $25 per month. You will no longer have restrictions on how many
                Rumbles you can create and how many responses you can view per
                Rumble.
              </p>
              <div className={'flex justify-center mb-6'}>
                <UpgradeAccountIcon />
              </div>
              <div className={'grid grid-cols-2 gap-3'}>
                <Button variant={'secondary'} onClick={closeModal}>
                  Later
                </Button>
                <SubscribeButtons />
              </div>
            </CustomModal>
          </>
        )}
        <div
          className={clsx(
            'relative flex-grow overflow-x-hidden overflow-y-auto pb-8 max-tablet:pb-24 group-[.fullModalOpen]:max-tablet:overflow-hidden',
            props.ready && !props.user
              ? 'bg-primary text-white'
              : 'bg-white text-primary',
            props.ready && props.user ? 'customScroll' : null
          )}
          style={whiteLabelOverrideStyle}
        >
          <Switch>
            <Route exact path='/' render={(props) => <HomePage />} />
            <Route
              path='/Share/:id/:responseId?'
              render={() => (
                <SharePage
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                />
              )}
            />
            <Route path='/SetupRumbleBranding'>
              <RequireLogin requireCompletedProfile>
                <WhiteLabelPage
                  props={props}
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                />
              </RequireLogin>
            </Route>
            <Route
              path='/Showdown'
              render={() => (
                <RumbleShowdownPage
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                />
              )}
            />
            <Route
              path='/List'
              render={() => (
                <ListPage
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                />
              )}
            />
            <Route path='/dashboard'>
              <RequireLogin requireCompletedProfile>
                <Dashboard
                  props={props}
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  resultsModal={openResultsModal}
                  videoModal={openVideoModal}
                  upgradeModal={openUpgradeModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                  isMobile={isMobile}
                  isResultsOpen={resultsModalIsOpen}
                  resultsRumbleID={(e) => setResultsRumbleID(e)}
                  duplicateRumbleID={(e) => setDuplicateRumbleID(e)}
                />
              </RequireLogin>
            </Route>
            <Route path='/create'>
              <RequireLogin requireCompletedProfile>
                <Create
                  logOutModal={openLogOutModal}
                  editModal={openEditModal}
                  videoModal={openVideoModal}
                  upgradeModal={openUpgradeModal}
                  isEditOpen={editModalIsOpen}
                  isFullOpen={fullModalIsOpen}
                  isMobile={isMobile}
                  duplicateRumbleID={duplicateRumbleID}
                  resetDuplicateRumbleID={() => setDuplicateRumbleID(null)}
                />
              </RequireLogin>
            </Route>
          </Switch>
        </div>
      </main>
    </Router>
  );
}

function mapStateToProps(state: any) {
  return {
    user: getUser(state),
    ready: isUserReady(state),
    currentList: getCurrentListInfo(state),
  };
}

export default connect(mapStateToProps, { setCurrentUser })(App);
